import { Api, ApiResponse } from './api';

export class WidgetGroupApi {
    constructor(
        public readonly url: string,
        private readonly pwgid: number,
        private readonly api: typeof Api,
    ) {}

    async post(data: Record<string, unknown>): Promise<ApiResponse> {
        return this.api.api_post(`${this.url}/api/widget_group/${this.pwgid}`, data);
    }

    async putLanguage(lang: string, data: Record<string, unknown>): Promise<ApiResponse> {
        return this.api.api_put(`${this.url}/api/widget_group/${this.pwgid}`, data, lang);
    }

    async postBulk(data: Record<number, unknown>): Promise<ApiResponse> {
        return this.api.api_post(`${this.url}/api/widget_group/bulk`, data);
    }

    async putLanguageBulk(lang: string, data: Record<number, unknown>): Promise<ApiResponse<{[key: number]: number}>> {
        return this.api.api_put<{[key: number]: number}>(`${this.url}/api/widget_group/bulk`, data, lang);
    }
}
